export const pr = [
    {
        "anio" : "Programa Anual de Evaluación",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "2025",
                "url" : "/Ed"
            },
            /*{
                "trimestre" : "Segunda Sesión 2024",
                "url" : "/pdf/2Acocodi.pdf"
            },
            {
                "trimestre" : "Tercera Sesión 2024",
                "url" : "/pdf/3Acocodi.pdf"
            },
            {
                "trimestre" : "Cuarta Sesión 2024",
                "url" : "/pdf/4Acocodi.pdf"
            },
            {
                "trimestre" : "Primera Sesión 2025",
                "url" : "/pdf/1A25cocodi.pdf"
            },*/
            
        ]
    },
    {
        "anio" : "",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Programa Anual de Evaluación",
                "url" : "/pdf/PAE2025.pdf"
            },
            {
                "trimestre" : "Evaluación",
                "url" : "/Ev"
            },
            {
                "trimestre" : "Monitoreo",
                "url" : "/Pr"
            },
            
            
        ]
    },
    {
        "anio" : "",
        "descripcion" : "Monitoreo",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre 2025",
                "url" : "/Transparencia/zip/monitoreoTrim12025.zip"
            },
            {
                "trimestre" : "Segundo Trimestre 2025",
                "url" : "/Transparencia/zip/monitoreoTrim22025.zip"
            },
            {
                "trimestre" : "Tercer Trimestre 2025",
                "url" : "/Pr"
            },
            {
                "trimestre" : "Cuarto Trimestre 2025",
                "url" : "/Pr"
            }
            
            
        ]
    }
]